import type { Adventure } from '../../types'

// Number Neighbors - Age 4-5 - Before and after numbers
export const tillyNeighborsCorrect = [
  "Perfect! You know the number neighbors!",
  "That's right! Before and after!",
  "Excellent! You know number order!",
  "Wonderful! Great number sense!",
  "Yes! That's the neighbor!",
  "Brilliant! You know what comes next!",
  "Super job! Number line master!",
  "You got it! The neighbor number!",
  "Fantastic! You see the pattern!",
  "Amazing! You're a numbers expert!"
]

export const tillyNeighborsWrong = [
  "Think about the number line! What comes before?",
  "Almost! Count up or down by 1!",
  "Good try! The number right next to it!",
  "So close! Before means one less!",
  "What number is right next to it?",
  "You're learning! Count: 4, 5, 6!",
  "Try again! It is just one away!",
  "Before = one less, after = one more!",
  "Let's find the neighbors together!",
  "Keep trying! Numbers have neighbors!"
]

export const numberNeighborsAdventure: Adventure = {
  id: 'number-neighbors',
  title: 'Number Neighbors',
  theme: 'numbers',
  targetAge: '4',
  difficulty: 'medium',
  estimatedDuration: 9,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello neighbor! I am Tilly! Numbers have neighbors too! Just like you have neighbors on your street!",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look at number 5! Its neighbors are 4 (before) and 6 (after)! Can you find the number before 5?",
      duration: 5
    },
    choice1: [
      {
        id: 'before',
        label: 'Find before!',
        tillyLine: "What comes before?",
        nextState: 'quiz-1'
      },
      {
        id: 'after',
        label: 'Find after!',
        tillyLine: "What comes after?",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'number-recognition',
      question: 'What comes BEFORE 4?',
      tillyPrompt: 'One less than 4!',
      options: [
        { id: 'two', label: '2', isCorrect: false },
        { id: 'three', label: '3', isCorrect: true },
        { id: 'five', label: '5', isCorrect: false }
      ],
      targetNumber: 3
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Great! Now let's find what comes AFTER a number! After 7 comes 8! Can you find the after numbers?",
      duration: 4
    },
    choice2: [
      {
        id: 'next',
        label: 'Find next!',
        tillyLine: "What number comes next?",
        nextState: 'quiz-2'
      },
      {
        id: 'both',
        label: 'Find both!',
        tillyLine: "Before AND after!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'number-recognition',
      question: 'What comes AFTER 6?',
      tillyPrompt: 'One more than 6!',
      options: [
        { id: 'five', label: '5', isCorrect: false },
        { id: 'seven', label: '7', isCorrect: true },
        { id: 'eight', label: '8', isCorrect: false }
      ],
      targetNumber: 7
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Neighbor expert! Challenge Round: Find both neighbors and fill in the middle!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'number-recognition',
          question: 'What comes BEFORE 9?',
          tillyPrompt: 'One less than 9!',
          options: [
            { id: 'seven', label: '7', isCorrect: false },
            { id: 'eight', label: '8', isCorrect: true },
            { id: 'ten', label: '10', isCorrect: false }
          ],
          targetNumber: 8
        } as any,
        {
          id: 'challenge-2',
          type: 'number-recognition',
          question: 'What comes AFTER 11?',
          tillyPrompt: '11 plus 1!',
          options: [
            { id: 'ten', label: '10', isCorrect: false },
            { id: 'twelve', label: '12', isCorrect: true },
            { id: 'thirteen', label: '13', isCorrect: false }
          ],
          targetNumber: 12
        } as any,
        {
          id: 'challenge-3',
          type: 'number-recognition',
          question: 'What number is BETWEEN 7 and 9?',
          tillyPrompt: 'In the middle!',
          options: [
            { id: 'six', label: '6', isCorrect: false },
            { id: 'eight', label: '8', isCorrect: true },
            { id: 'ten', label: '10', isCorrect: false }
          ],
          targetNumber: 8
        } as any
      ]
    },
    reward: {
      tillyLine: "Incredible! You know all the number neighbors! You are a Number Neighbor Master!",
      badgeName: 'Neighbor Pro',
      badgeIcon: '🏠',
      nextPreview: 'Next time, we will be shape detectives!'
    }
  }
}
